import { render, staticRenderFns } from "./DownlineBody.vue?vue&type=template&id=1850a09a&scoped=true&"
import script from "./DownlineBody.vue?vue&type=script&lang=ts&"
export * from "./DownlineBody.vue?vue&type=script&lang=ts&"
import style0 from "./DownlineBody.vue?vue&type=style&index=0&id=1850a09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850a09a",
  null
  
)

export default component.exports